<div *ngIf="loading; else elseBlock" class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>

  <ng-template #elseBlock >

    <div style="display: flex;justify-content: space-between;flex-direction: column;height: 100%;">
      <h2>Seleccionar los tipos de equipos para el file {{data.file.fileNumber}}</h2>

 <!--      <mat-form-field appearance="outline" style="width: 100%;font-size: 14px">
        <mat-label>Filtrar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda"/>
      </mat-form-field> -->

    <div class="mat-elevation-z8">
      <mat-table [dataSource]="dataSource" matSort >

        <!-- <ng-container matColumnDef="Check">

          <mat-header-cell  *matHeaderCellDef>
            <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="isAllSelected()">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell  *matCellDef="let element"><mat-checkbox [checked]="element.selected" (change)="updateCheck(element)">
          </mat-checkbox></mat-cell>
        </ng-container> -->

        <ng-container matColumnDef="nombre">
          <mat-header-cell  *matHeaderCellDef>Nombre</mat-header-cell>
          <mat-cell  *matCellDef="let element">{{ element?.agrupadoInfo.nombreEquipo }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="marca">
          <mat-header-cell  *matHeaderCellDef>Marca</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.agrupadoInfo.marcaEquipo }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="modelo">
          <mat-header-cell  *matHeaderCellDef>Marca</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.agrupadoInfo.modeloEquipo }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="talla">
          <mat-header-cell  *matHeaderCellDef>Talla</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.agrupadoInfo.tallaEquipo }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="peso">
          <mat-header-cell  *matHeaderCellDef>Peso</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.agrupadoInfo.pesoEquipo }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="cantidad">
          <mat-header-cell  *matHeaderCellDef>Cantidad</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.agrupadoInfo.nroPersonasPax[data.file.cantPax-1] }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="editar">
          <th mat-header-cell *matHeaderCellDef> Asignar</th>
          <td mat-cell *matCellDef="let element;let i=index">
            <button mat-icon-button class="edit-asignar" (click)="openDialogAsignarEquipo(element,i)">
                <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <mat-header-row  *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row  *matRowDef="let row; columns: displayedColumns"></mat-row>

      </mat-table>
    </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

    <div style="display: flex;justify-content: center">
      <button mat-raised-button class="buttonPrimary" (click)="closeDialogAssing()">Cerrar</button>
    </div>
    </div>
    
  </ng-template>
